import { Box, Button, Skeleton, Tooltip } from '@mui/material'
import { useEffect, useRef } from 'react'
import CloseIcon from '@mui/icons-material/Close';
import { ArrowBack } from '@mui/icons-material';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { SiteIdentity } from './theme/SiteIdentity';
import { Colors } from './theme/Colors'
import TabletIcon from "@mui/icons-material/Tablet";
import DesktopWindowsIcon from "@mui/icons-material/DesktopWindows";
import PhoneIphoneIcon from "@mui/icons-material/PhoneIphone";

export const Side = ({ method, errors, tLoader, showPicker, togglePicker, themeBtn, openModal, handleChange, templateForm, handleThemes, sideBarContent, showSidebar, closeSidebar, company_id }) => {
    const tab = new URLSearchParams(window.location.search).get("tab")
    const history = useHistory()
    const back = () => {
        history.push('/campaign/website?type=real-property&tab=list&offer_type=rent&property_type=all');
        showSidebar.set(false);
    }
    const pickerRef = useRef(null);
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (pickerRef.current && !pickerRef.current.contains(event.target)) {
                showPicker.set({
                    header: { bg: false, btn: { bg: false, color: false }, title_color: false },
                    buttons: { bg: true, colors: false }
                })
                sideBarContent.set({ ...sideBarContent.data, site_color: false, })
            }
        }
        if (showPicker.data.buttons.bg || showPicker.data.header.bg || showPicker.data.header.btn.bg) {
            document.addEventListener("mousedown", handleClickOutside);
        }
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
        // eslint-disable-next-line
    }, [showPicker.data, sideBarContent.data]);

    const buttonStyles = {
        color: '#fff',
        borderColor: '#fff',
        fontSize: 12,
        ':hover': { borderColor: '#fff', color: '#fff' }
    };
    const getButtons = () => {
        const status = templateForm.data.status;
        const buttons = [];
        if (status === undefined) {
            buttons.push(<Button key="save" onClick={() => openModal('submit', 1, "save")} sx={buttonStyles} fullWidth variant="outlined">Save</Button>);
            buttons.push(<Button key="publish" onClick={() => openModal('submit', 2, "publish")} sx={buttonStyles} fullWidth variant="outlined">Publish</Button>);
        }
        if (status === 1) {
            buttons.push(<Button key="saved" sx={buttonStyles} fullWidth variant="outlined" disabled>Saved</Button>);
            buttons.push(<Button key="publish" onClick={() => openModal('submit', 2, "publish")} sx={buttonStyles} fullWidth variant="outlined">Publish</Button>);
        }
        if (status === 2) {
            buttons.push(<Button key="published" sx={buttonStyles} fullWidth variant="outlined" disabled>Published</Button>);
            buttons.push(<Button key="update" onClick={() => openModal('submit', 2, 'update')} sx={buttonStyles} fullWidth variant="outlined">Update</Button>);
        }
        return buttons;
    };

    return (
        <Box height="100%" width="100%" position="relative" boxShadow={'0 4px 12px rgba(0, 0, 0, 0.1)'}>
            <Box width="100%" height="6%" display="flex" alignItems="center">
                <Box onClick={() => back()} display="flex" alignItems="center" justifyContent="center"
                    sx={{ width: "100%", height: "100%", bgcolor: "#CECECE", gap: 1, cursor: "pointer" }}
                >
                    <ArrowBack sx={{ color: '#009F4D', fontSize: 22 }} />
                    <Box sx={{ display: "flex", alignItems: "center", color: '#008000' }}>Back</Box>
                </Box>
            </Box>
            {
                (!themeBtn.data.theme && method === null) ?
                    <Box width="100%" height={40} display="flex" justifyContent="center" flexDirection="column" bgcolor="#009F4D" color="#fff" textAlign="center">
                        Theme
                    </Box>
                    :
                    <Box bgcolor="#009F4D" display="flex" alignItems="center" gap={1} p={1} >
                        <CloseIcon sx={{ cursor: 'pointer', color: '#fff' }} onClick={() => handleThemes('close-theme')} />
                        {
                            !tLoader.data ?
                                <Box display="flex" alignItems="center" gap={0.5} height={40}>
                                    {getButtons()}
                                </Box>
                                :
                                <Box width="100%" display="flex" justifyContent="space-between" alignItems="center" gap={0.5} height={40}>
                                    <Skeleton variant="rectangular" width="100%" height="100%" sx={{ borderRadius: 2, border: "solid 1px", color: '#fff' }} />
                                    <Skeleton variant="rectangular" width="100%" height="100%" sx={{ borderRadius: 2, border: "solid 1px", color: '#fff' }} />
                                </Box>
                        }
                    </Box>
            }
            {themeBtn.data.theme === true && (
                <Box width="100%" mt={2}>
                    <Box width="100%" mt={2} px={2} display="flex" flexDirection="column" alignItems="center" gap={2}>
                        <Box width="100%">
                            <Button variant={themeBtn.data.themeOption ? "contained" : "outlined"} fullWidth onClick={() => handleThemes('option')} >
                                Theme Options
                            </Button>
                            {
                                themeBtn.data.themeOption &&
                                <Box width="100%" p={1} borderRadius="0px 0px 10px 10px" borderBottom="solid 1px #ddd" borderLeft="solid 1px #ddd" borderRight="solid 1px #ddd" display="flex" alignItems="center" flexDirection="column" gap={1}>
                                    <Button fullWidth onClick={() => handleThemes('site_colors')}
                                        // variant={sideBarContent.data.site_color ? "contained" : "outlined"}
                                        sx={{
                                            height: 35,
                                            fontSize: 14,
                                            bgcolor: sideBarContent.data.site_color ? "#9B9B9B" : "transparent",
                                            border: `solid 1px ${sideBarContent.data.site_color ? "#9B9B9B" : "#417505"}`,
                                            color: sideBarContent.data.site_color ? "#22450B" : "#417505",
                                            ":hover": { bgcolor: "#9B9B9B", color: "#22450B" }
                                        }}
                                    >
                                        Site Colors
                                    </Button>
                                </Box>
                            }
                        </Box>
                        <Box width="100%">
                            <Button onClick={() => handleThemes('identity')} fullWidth variant={sideBarContent.data.site_identity ? "contained" : "outlined"}>Site Identity</Button>
                        </Box>
                    </Box>
                </Box>
            )}

            {showSidebar.data && (
                <Box height="100%" width={300} position="absolute" left={220} top={0} boxShadow="0 2px 8px rgba(0, 0, 0, 0.2)" zIndex={1} sx={{ backgroundColor: 'background.default' }}
                    // border="solid 1px"
                >
                    <Box height="100%" width="100%">

                        <Box display="flex" justifyContent="flex-end" p={1} borderBottom="solid 1px #CCC">
                            {themeBtn.data.themeOption ? <CloseIcon onClick={() => closeSidebar('sc')} sx={{ cursor: 'pointer', mt: 1.5 }} /> :
                                <CloseIcon onClick={() => closeSidebar('si')} sx={{ cursor: 'pointer', mt: 1.5 }} />}
                        </Box>

                        <Box width="100%" height="94%" className='overflowY'> 

                            {showPicker.data.buttons.bg && <Colors showPicker={showPicker} templateForm={templateForm} handleChange={handleChange}/>}
                            {sideBarContent.data.site_identity &&
                                <SiteIdentity
                                    errors={errors}
                                    company_id={company_id}
                                    pickerRef={pickerRef}
                                    openModal={openModal}
                                    handleChange={handleChange}
                                    templateForm={templateForm}
                                    togglePicker={togglePicker}
                                    showPicker={showPicker} />
                            }
                        </Box>
                    </Box>
                </Box>
            )}
            <Box width="100%" display="flex" alignItems="center" justifyContent="center" sx={{ bottom: "1.5rem", position: "absolute" }}>
                <Tooltip title="Not yet available">
                    <DesktopWindowsIcon fontSize="large" sx={{ width: 60, bgcolor: tab === 'desktop' ? "#CECECE" : false, color: tab === 'desktop' ? "#009F4D" : "#CECECE", borderRadius: 1, py: 0.5, ":hover": { bgcolor: "#CECECE", color: "#009F4D" } }} />
                </Tooltip>
                <Tooltip title="Not yet available">
                    <TabletIcon fontSize="large" sx={{ width: 60, bgcolor: tab === 'tablet' ? "#CECECE" : false, color: tab === 'tablet' ? "#009F4D" : "#CECECE", borderRadius: 1, py: 0.5, ":hover": { color: "#009F4D", ":hover": { bgcolor: "#CECECE", color: "#009F4D" } } }} />
                </Tooltip>
                <Tooltip title="Mobile">
                    <PhoneIphoneIcon fontSize="large" sx={{ width: 60, bgcolor: tab === 'mobile' ? "#CECECE" : false, color: tab === 'mobile' ? "#009F4D" : "#CECECE", borderRadius: 1, py: 0.5, ":hover": { bgcolor: "#CECECE", color: "#009F4D" } }} />
                </Tooltip>
            </Box>
        </Box>
    )
}
